/**
 * Tipos de ingresso oferecidos no wizard, compartilhados por aula e espaço de
 * locação.
 *
 * Mora aqui, e não duplicado nos dois formulários, porque a ordem e a redação
 * são recomendação de produto: quem lê os três cartões está escolhendo o nível
 * de conferência da portaria, e a mesma escolha tem de ser apresentada do mesmo
 * jeito nos dois lugares.
 *
 * A ordem é deliberada. QR primeiro porque é o único em que a credencial é um
 * segredo de verdade — 128 bits que só existem naquele ingresso. CPF por último
 * porque documento IDENTIFICA mas não é segredo: muita gente sabe o CPF de
 * outra, e quem de fato confere é o validador olhando o nome na tela.
 */
export const TICKET_TYPE_CARDS = [
  {
    value: 'QR',
    title: 'QR Code',
    description:
      'O aluno mostra um QR no celular e a portaria lê pela câmera. É o mais rápido e o mais seguro.',
    example: 'Ex.: leitura em ~1 segundo, sem digitar nada',
    icon: 'MaximizeIcon',
  },
  {
    value: 'COD',
    title: 'Código',
    description:
      'O aluno apresenta um código curto e a portaria digita. Útil quando não dá para usar câmera.',
    example: 'Ex.: ABCD-2345',
    icon: 'HashIcon',
  },
  {
    value: 'CPF',
    title: 'CPF',
    description:
      'O aluno informa o CPF na recepção. Não exige levar nada, mas depende de o validador conferir o nome.',
    example: 'Ex.: 000.000.000-00',
    icon: 'UserIcon',
  },
]

/**
 * Campos de ingresso prontos para o payload de gravação.
 *
 * O tipo vai nulo quando o ingresso está desligado: o CHECK do banco recusa a
 * combinação "sem ingresso, mas com tipo", e deixar o valor antigo para trás
 * faria a gravação falhar com erro de restrição em vez de mensagem útil.
 */
export function ticketPayload(model) {
  const enabled = !!(model && model.ticket_enabled)

  return {
    ticket_enabled: enabled,
    ticket_type: enabled ? (model.ticket_type || null) : null,
  }
}
